import {
  makeStyles,
  TableRow,
  TableCell,
  Table,
  TableHead,
  TableBody
} from "@material-ui/core";

import { CSVMetadataValid } from "src/util/csv";

const useCsvPreviewStyles = makeStyles(() => ({
  container: {
    overflowX: "scroll"
  }
}));

export default function CsvPreview({
  csvMetadata
}: {
  csvMetadata: CSVMetadataValid;
}): JSX.Element {
  const classes = useCsvPreviewStyles();

  return (
    <div className={classes.container}>
      <Table>
        <TableHead>
          <TableRow>
            {csvMetadata.columns.map(c => (
              <TableCell key={c}>{c}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {csvMetadata.sampleRows.map((r, i) => (
            <TableRow key={i}>
              {csvMetadata.columns.map(c => (
                <TableCell key={c}>{r[c]}</TableCell>
              ))}
            </TableRow>
          ))}
          {csvMetadata.sampleRows.length < csvMetadata.rows ? (
            <TableRow>
              <TableCell colSpan={csvMetadata.columns.length}>
                ...and {csvMetadata.rows - csvMetadata.sampleRows.length} more
                rows
              </TableCell>
            </TableRow>
          ) : null}
        </TableBody>
      </Table>
    </div>
  );
}
